import styled from "styled-components";
import { ReactComponent as Star } from "./star.svg";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  line-height: 1.5;
  gap: 12px;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    line-height: 1.3;
    flex-wrap: wrap;
    row-gap: 4px;
  }
`;

export const StarIcon = styled(Star)`
  width: 24px;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    width: 16px;
  }
`;

export const Rate = styled.span`
  font-weight: 600;
  font-size: 16px;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    font-size: 13px;
  }
`;

export const Votes = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.color.darkergrey};

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    font-size: 13px;
  }
`;
